import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles(() => ({
  customerListViewWrapper: {
    paddingTop: 100,
    margin: '0 auto',
    paddingBottom: 100
  },
  examsHeader: {
    color: "black", 
    fontSize: "35px", 
    lineHeight: "50px",
    paddingBottom: '40px',
    width: '100%',
    textAlign: 'center'
  },
  tableCell: {
    padding: 15,
    borderBottom: '1px solid black',
  },
  tableHeadRow: {
    border: '1px solid black',
  },
  tableRow: {
    borderLeft: '1px solid black',
    borderRight: '1px solid black'
  },
  actionButtonsWrapper: {
    display: 'flex',
    flexDirection: 'row'
  }
}));